import { useSyncExternalStore } from 'react';
import './ScrollToTop.scss';
import arrowUpIcon from '@/assets/icons/arrow-up.svg';

function subscribe(callback: () => void) {
  window.addEventListener('scroll', callback, { passive: true });
  return () => window.removeEventListener('scroll', callback);
}

function getSnapshot(): boolean {
  // Appears after scrolling 0.5 screen height
  const threshold = window.innerHeight * 0.5;
  return window.scrollY > threshold;
}

function getServerSnapshot(): boolean {
  return false;
}

export function ScrollToTop() {
  const isVisible = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <button
      className={`scroll-to-top${isVisible ? ' scroll-to-top--visible' : ''}`}
      onClick={scrollToTop}
      type="button"
      aria-label="Remonter en haut de la page"
    >
      <img src={arrowUpIcon} alt="" aria-hidden="true" width={24} height={24} />
    </button>
  );
}

export default ScrollToTop;
